<template>
    <div class="footer-container">
        <div class="footer-wrapper">
            <div class="footer-content">
                <div>
                    <div class="footer-content-title">新手指南</div>
                    <div class="footer-content-label">如何注册</div>
                    <div class="footer-content-label">找回密码</div>
                    <div class="footer-content-label">如何选课</div>
                    <div class="footer-content-label">开通课程</div>
                </div>
                <div>
                    <div class="footer-content-title">关于课程</div>
                    <div class="footer-content-label">如何试听</div>
                    <div class="footer-content-label">如何听课</div>
                    <div class="footer-content-label">公开课预约</div>
                    <div class="footer-content-label">课件离线</div>
                </div>
                <div>
                    <div class="footer-content-title">网校产品</div>
                    <div class="footer-content-label">汇学堂</div>
                </div>
                <div>
                    <div class="footer-content-title">网校产品</div>
                    <div class="footer-content-label">课程有效期</div>
                    <div class="footer-content-label">退换课规定</div>
                    <div class="footer-content-label">发票开具事宜</div>
                    <div class="footer-content-label">优惠卷使用流程</div>
                </div>
                <div>
                    <div>
                        <img src="@/assets/img/ercode.png" alt="" class="ercode-img">
                    </div>
                    <div class="ercode-label">网校公众号</div>
                </div>
                <div>
                    <div>
                        <img src="@/assets/img/ercode.png" alt="" class="ercode-img">
                    </div>
                    <div class="ercode-label">汇学堂公众号</div>
                </div>
                <div>
                    <div class="footer-info-item">
                        <div class="footer-info-icon-wrapper" style="background:#F1858D;">
                            <i class="el-icon-phone footer-info-icon"></i>
                        </div>
                        <div class="footer-info-label">24小时客服电话：400-600-8999</div>
                    </div>
                    <div class="footer-info-item">
                        <div class="footer-info-icon-wrapper" style="background:#85A5FB;">
                            <i class="el-icon-message footer-info-icon"></i>
                        </div>
                        <div class="footer-info-label">客服邮箱：644163061@qq.com</div>
                    </div>
                    <div class="footer-info-item">
                        <div class="footer-info-icon-wrapper" style="background:#98E8C5;">
                            <i class="el-icon-chat-dot-round footer-info-icon"></i>
                        </div>
                        <div class="footer-info-label" style="color:#4F79ED;">
                            在线咨询
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-link-wrapper">
                <div class="footer-link-title">友情链接</div>
                <div class="footer-link-label">中国税务报</div>
                <div class="footer-link-label">中国税务报</div>
                <div class="footer-link-label">中国税务报</div>
                <div class="footer-link-label">中国税务报</div>
                <div class="footer-link-label">中国税务报</div>
                <div class="footer-link-label">中国税务报</div>
                <div class="footer-link-label">中国税务报</div>
                <div class="footer-link-label">中国税务报</div>
                <div class="footer-link-label">中国税务报</div>
                <div class="footer-link-label">中国税务报</div>
            </div>
            <div class="footer-right-en">
                Copyright @ 2005-2016 Tax-China Inc. All Rights Reserved 北京中税网控股股份有限公司版权所有
            </div>
            <div class="footer-right-cn">
                京ICP备09044954号-2  京ICP证160868号            
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    components:{
      
    },
    data() {
        return {
            
        }
    },
    mounted(){
        
    },
    methods: {
        
    }
}
</script>

<style scoped>
.footer-container{
    width:100%;
    border-top:solid 4px #85A5FB;
    background: #fff;
}
.footer-wrapper{
    width:1200px;
    margin:0 auto;
    margin-top:49px;
}
.footer-content{
    width:100%;
    display:flex;
    justify-content: space-between;
    padding-bottom:50px;
    border-bottom:solid #F0F0F0 1px;
}
.footer-content-title{
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #121212;
}
.footer-content-label{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    margin-top:8px;
}
.footer-content-label:hover{
    cursor:pointer;
    color:#85A5FB;
}
.ercode-img{
    width:100px;
    height:100px;
}
.ercode-label{
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #121212;
    text-align: center;
    margin-top:10px;
}
.footer-info-item{
    display:flex;
    align-items: center;
    margin-bottom:15px;
}
.footer-info-icon-wrapper{
    width:28px;
    height:28px;
    border-radius:50%;
    color:#fff;
    display: flex;
    align-items: center;
    justify-content: center;
}
.footer-info-icon{
    font-size: 18px;;
}
.footer-info-label{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    margin-left:17px;
}
.footer-link-wrapper{
    margin-top:29px;
    display: flex;
    align-items: center;
}
.footer-link-label{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    margin-left:29px;
}
.footer-link-label:hover{
    cursor:pointer;
    color:#85A5FB;
}
.footer-right-en{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    margin-top:30px;
}
.footer-right-cn{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    margin-top:13px;
    padding-bottom:80px;
}
</style>


